import React from 'react';
import { HashLink } from 'react-router-hash-link';
import BrandLogo from '../components/BrandLogo';

export default function HeroSection() {
  return (
    <section id="hero">
      <div className="hero-bg" />
      <div className="hero-left">
        <div className="eyebrow">Advanced Masterbatch &amp; Additive Solutions</div>
        <h1>
          Engineering
          <br />
          <em>color.</em>
          <br />
          Advancing
          <br />
          sustainability.
        </h1>
        <div className="h-rule" />
        <p className="h-desc">
          Auralux engineers high-performance color concentrates and functional masterbatches for the world&apos;s most
          demanding polymer applications — where chemistry, precision, and sustainability align.
        </p>
        <div className="h-btns">
          <HashLink smooth to="#solutions" className="btn-p">
            Explore Solutions
          </HashLink>
          <HashLink smooth to="#contact" className="btn-g">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
              <path
                d="M1 7h12M8 2l5 5-5 5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Request a Sample
          </HashLink>
        </div>
        <div className="h-kpis">
          <div>
            <div className="kpi-v">50+</div>
            <div className="kpi-l">Countries Served</div>
          </div>
          <div>
            <div className="kpi-v">2,400+</div>
            <div className="kpi-l">Formulations</div>
          </div>
          <div>
            <div className="kpi-v">FDA</div>
            <div className="kpi-l">21 CFR Ready</div>
          </div>
          <div>
            <div className="kpi-v">ISO</div>
            <div className="kpi-l">9001 &amp; 14001</div>
          </div>
        </div>
      </div>

      <div className="hero-right">
        <div className="stage">
          <div className="stage-glow" />
          <div className="hero-mark-wrap">
            <div className="hero-mark-3d">
              <BrandLogo variant="mark" placement="hero" className="hero-mark-img" />
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-cue">
        <div className="sc-line" />
        <span className="sc-text">Scroll</span>
      </div>
    </section>
  );
}
